import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.6' }}>
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> April 14, 2026</p>
      <p><strong>Last Updated:</strong> April 14, 2026</p>

      <h2>1. Introduction</h2>
      <p>
        Welcome to Sai Ananta ("we," "our," or "us"). We are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or interact with our services.
      </p>
      <p>
        By using our website or submitting your information, you agree to the terms outlined in this Privacy Policy. If you do not agree with our policies, please do not use our website.
      </p>

      <h2>2. Information We Collect</h2>
      
      <h3>2.1 Personal Information</h3>
      <p>We may collect the following personal information when you interact with our website:</p>
      <ul>
        <li>Full Name</li>
        <li>Email Address</li>
        <li>Phone Number/Mobile Number</li>
        <li>Preferred Visit Date (for site visits)</li>
        <li>Any other information you voluntarily provide through forms, emails, or communication</li>
      </ul>

      <h3>2.2 Automatically Collected Information</h3>
      <p>When you visit our website, we may automatically collect certain information, including:</p>
      <ul>
        <li>IP Address</li>
        <li>Browser Type and Version</li>
        <li>Device Information</li>
        <li>Operating System</li>
        <li>Pages Visited and Time Spent</li>
        <li>Referral Source</li>
        <li>Location Data (with your consent)</li>
      </ul>

      <h3>2.3 Cookies and Tracking Technologies</h3>
      <p>
        We use cookies and similar tracking technologies to enhance your experience on our website. Cookies are small text files stored on your device that help us remember your preferences and improve website functionality.
      </p>
      <p>You can control cookies through your browser settings. However, disabling cookies may affect certain features of our website.</p>

      <h2>3. How We Use Your Information</h2>
      <p>We use the collected information for the following purposes:</p>
      <ul>
        <li>To respond to your enquiries and provide information about Sai Ananta</li>
        <li>To schedule and confirm site visits</li>
        <li>To communicate updates, offers, and promotional materials about our properties</li>
        <li>To improve our website and services</li>
        <li>To analyze website usage and user behavior</li>
        <li>To comply with legal obligations and prevent fraud</li>
        <li>To personalize your experience on our website</li>
      </ul>

      <h2>4. How We Share Your Information</h2>
      <p>We respect your privacy and do not sell your personal information to third parties. However, we may share your information in the following circumstances:</p>
      
      <h3>4.1 With Service Providers</h3>
      <p>We may share your information with trusted third-party service providers who assist us in operating our website, conducting business, or servicing you (e.g., email service providers, analytics platforms).</p>

      <h3>4.2 With Business Partners</h3>
      <p>We may share information with our developers, builders, and financial partners to facilitate property transactions and provide you with comprehensive services.</p>

      <h3>4.3 For Legal Compliance</h3>
      <p>We may disclose your information if required by law, court order, or government regulation, or to protect our rights, property, and safety.</p>

      <h3>4.4 Business Transfers</h3>
      <p>In the event of a merger, acquisition, or sale of assets, your information may be transferred as part of the transaction.</p>

      <h2>5. Data Security</h2>
      <p>
        We implement industry-standard security measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure. While we strive to protect your information, we cannot guarantee absolute security.
      </p>

      <h2>6. Your Rights</h2>
      <p>You have the following rights regarding your personal information:</p>
      <ul>
        <li><strong>Access:</strong> You can request a copy of the personal information we hold about you.</li>
        <li><strong>Correction:</strong> You can request that we correct or update inaccurate information.</li>
        <li><strong>Deletion:</strong> You can request that we delete your personal information, subject to legal obligations.</li>
        <li><strong>Opt-Out:</strong> You can opt out of receiving promotional emails by clicking the "unsubscribe" link in our emails.</li>
        <li><strong>Data Portability:</strong> You can request a copy of your data in a structured, machine-readable format.</li>
      </ul>
      <p>To exercise any of these rights, please contact us at <strong>info@saiananta.com</strong> or call <strong>+91 70663 31177</strong>.</p>

      <h2>7. Retention of Information</h2>
      <p>
        We retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy or as required by law. When your information is no longer needed, we will securely delete or anonymize it.
      </p>

      <h2>8. Third-Party Links</h2>
      <p>
        Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these external sites. We encourage you to review their privacy policies before providing any personal information.
      </p>

      <h2>9. Children's Privacy</h2>
      <p>
        Our website is not intended for individuals under the age of 18. We do not knowingly collect personal information from children. If we become aware that we have collected information from a child, we will take steps to delete it promptly.
      </p>

      <h2>10. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. The updated policy will be posted on this page with a revised "Last Updated" date. We encourage you to review this policy periodically.
      </p>

      <h2>11. Contact Us</h2>
      <p>If you have any questions, concerns, or requests regarding this Privacy Policy, please contact us:</p>
      <p>
        <strong>Sai Ananta</strong><br />
        Laxmi-Narayan Nagar, Wadmukhwadi, Charholi Budruk, Pimpri-Chinchwad, Maharashtra 412105, Maharashtra, India<br />
        <strong>Phone:</strong> +91 70663 31177<br />
        <strong>Email:</strong> info@saiananta.com<br />
        <strong>Website:</strong> https://sai-ananta-website.vercel.app/
      </p>

      <h2>12. Consent</h2>
      <p>
        By using our website and providing your information, you consent to the collection, use, and disclosure of your information as described in this Privacy Policy.
      </p>

      <hr style={{ margin: '40px 0', border: 'none', borderTop: '1px solid #ccc' }} />
      <p style={{ fontSize: '14px', color: '#666' }}>
        This Privacy Policy is governed by the laws of India and complies with the Information Technology Act, 2000, and applicable data protection regulations.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
